function popover(event){
    let target;
    if (
        (event.target instanceof HTMLElement)
        &&(target = event.target.closest('.date-time-container.bs_popover'))
        &&(!target.matches('[aria-describedby]'))
    ) {
        let cookie = document.cookie.split(/;\s?/).find((c)=>!c.indexOf(window.gl_cookie_help_status));
        if (!cookie||parseInt(cookie.split("=")[1])) {
            $(target).popover('show');
        }
    }
    document.querySelectorAll('.date-time-container.bs_popover[aria-describedby]').forEach((e)=>(e===target)?null:$(e).popover('hide'));
}

function dateTime(event) {
    let container, input, date, time;

    if (
        (event.target instanceof HTMLElement)
        &&(container=event.target.closest('.date-time-container'))
        &&(input=container.parentNode.querySelector('input[name]'))
        &&(date=container.querySelector('input[type="date"]'))
        &&(time=container.querySelector('input[type="time"]'))
    ) {
        if (date.value === '' && time.value === '') {
            input.value = '';
        } else {
            const dateValue = date.value === '' ? new Date().toISOString() : date.valueAsDate.toISOString();
            input.value = dateValue.replace(/T.*$/, 'T'+(time.value||'00:00:00'));
        }
    }
}

window.addEventListener('change',  dateTime);
window.addEventListener('input',  dateTime);

window.addEventListener('mousedown',  popover);
window.addEventListener('touchstart', popover);
